import BuildingsApi from '@/api/buildings-api'
import EditBuilding from '@/components/EditBuilding'
import CreateBuilding from '@/components/CreateBuilding'

import FilterTable from '@/helpers/FilterTable.js'

export default {
    components: {
        EditBuilding,
        CreateBuilding
    },
    mixins: [FilterTable],
    data() {
        return {
            // headers for the table
            headers: [
                {
                    text: this.$t('buildingGenerics.buildingId'),
                    align: 'center',
                    sortable: false,
                    value: 'building_id'
                },
                {
                    text: this.$t('buildingGenerics.buildingName'),
                    value: 'building_name',
                    align: 'center'
                },
                {
                    text: this.$t('buildingGenerics.buildingDescr'),
                    value: 'description',
                    align: 'center'
                },
                {
                    text: this.$t('siteGenerics.siteName'),
                    value: 'site_name',
                    align: 'center'
                }
            ],
            buildings: [],
            sites: [],
            editBuildingModalVisible: false,
            createBuildingModalVisible: false,
            clickedId: null,
            loading: false,
            filteredBuildings: []
        }
    },
    async mounted() {
        await this.loadData()
    },
    methods: {
        async loadData() {
            try {
                this.loading = true
                this.error = null
                this.buildings = (await BuildingsApi.list()).data
                if (this.buildings)
                    this.buildings = this.buildings.map((b) => ({
                        ...b, site_name: b.site && b.site.site_name
                    }))
                this.filteredBuildings = this.buildings
                this.loading = false
            } catch (err) {
                this.error = err.response.data.error.message
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/_buildings/buildings.js